var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-var */
/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable quotes */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import intlTelInput from "intl-tel-input";
import { FcaLeadUtils } from "./FcaLeadUtils";
import { utils } from "./utils";
import { phone } from "./phone";
import { personalInfo } from "./personalInfo";
import { governmentInfo } from "./governmentInfo";
import { LeadTrackerCoockie } from "./leadTrackerCookie";
import { BuildErrorMessages } from "./buildErrorMessages";
import { BuildDlronTypes } from "./buildDlronTypes";
import { FormField } from "@dealeron/tagging-types";
let leadbaaTaggingPiiFix_DO48757 = false;
let leadbaaGA4Comment_DO56658 = false;
let useTaggbaaOemTaggingShiftOnly_DO50909 = false;
let apexCreditExtendedFields_OEM14704 = false;
const describeError = (e) => e instanceof Error ? e.message : "Unknown error";
export const getToggleValue = (toggleName) => {
    const blk = document.getElementById("do-release-toggles");
    if (!(blk === null || blk === void 0 ? void 0 : blk.textContent))
        return false;
    try {
        const toggles = JSON.parse(blk.textContent);
        return !!toggles[toggleName];
    }
    catch (_a) {
        return false;
    }
};
// Function to update the variable
export const updateToggle = () => {
    leadbaaTaggingPiiFix_DO48757 = getToggleValue("LeadbaaTaggingPiiFix_DO48757");
    leadbaaGA4Comment_DO56658 = getToggleValue("LeadbaaGA4Comment_DO56658");
    useTaggbaaOemTaggingShiftOnly_DO50909 = getToggleValue("UseTaggbaaOemTaggingShiftOnly_DO50909");
    apexCreditExtendedFields_OEM14704 = getToggleValue("ApexCreditExtendedFields_OEM14704");
};
// Observe the DOM for the element and its content
export const observeToggles = () => {
    const blk = document.getElementById("do-release-toggles");
    if (blk) {
        // Observe changes to textContent
        const observer = new MutationObserver(() => updateToggle());
        observer.observe(blk, { childList: true, subtree: true, characterData: true });
        // Initial update
        updateToggle();
    }
    else {
        // If not present, observe the document for its addition
        const docObserver = new MutationObserver((mutations, obs) => {
            const blkNow = document.getElementById("do-release-toggles");
            if (blkNow) {
                obs.disconnect();
                observeToggles();
            }
        });
        docObserver.observe(document.body, { childList: true, subtree: true });
    }
};
// Start observing
observeToggles();
export default class DealerOnLeadsNoJQuery {
    constructor() {
        //enums
        this.webTemplate = {
            RESPONSIVE: 4,
        };
        this.locale = {
            enUS: "1-0",
            enCA: "1-1",
            esUS: "2-0",
            esMX: "2-2",
            esCO: "2-3",
            esCL: "2-4",
            esPE: "2-5",
            ptBR: "3-6",
            esEC: "2-7",
            esPY: "2-8",
        };
        this.leadWindow = window;
        this.currentLocale = null;
        this.currentCountry = "us";
        // Store the URL on initial page load
        this.entryUrl = this.leadWindow.location.href;
        this.ShiftSessionId = null;
        this.inputMaskIsLoaded = false;
        this.inputMaskScriptElement = null;
        this.token = {
            value: null,
            lifetime: 60,
            delta: 20,
            obtained: null,
            consumed: false,
            shouldRefresh: () => {
                const now = new Date();
                return (this.token.value == null ||
                    this.token.consumed ||
                    this.token.addMinutes(this.token.obtained, this.token.lifetime - this.token.delta) < now);
            },
            addMinutes: (date, minutes) => {
                return new Date(date.getTime() + minutes * 60000);
            },
            refreshToken: (response) => {
                this.token.value = response.token;
                this.token.obtained = new Date();
                this.token.consumed = false;
            },
        };
        //data structures
        this.submissionMethods = {};
        this.dlronTypes = {};
        this.uploadedFiles = {};
        this.errMsg = {};
        this.defaultOverrides = {};
        this.thirdPartyJsonAdapter = {
            data: undefined,
            hasData: () => {
                return this.thirdPartyJsonAdapter.data !== undefined;
            },
            reset: () => {
                this.thirdPartyJsonAdapter.data = {};
            },
            getData: () => {
                const obj = this.thirdPartyJsonAdapter.data;
                if (typeof obj === "function") {
                    return this.thirdPartyJsonAdapter.data();
                }
                for (const prop in obj) {
                    const value = obj[prop];
                    if (typeof value === "function") {
                        try {
                            this.thirdPartyJsonAdapter.data[prop] = value();
                        }
                        catch (err) {
                            console.warn(prop + " on DealeronLead.thirdPartyJsonAdapter.data error");
                        }
                    }
                }
                return this.thirdPartyJsonAdapter.data;
            },
            setData: (obj) => {
                if (this.thirdPartyJsonAdapter.data === undefined) {
                    this.thirdPartyJsonAdapter.data = {};
                }
                if (typeof obj === "object") {
                    for (const prop in obj) {
                        this.thirdPartyJsonAdapter.data[prop] = obj[prop];
                    }
                }
            },
        };
        //U.S. states, territories, commonwealths, and military "state" codes
        this.states = [
            "AL",
            "AK",
            "AZ",
            "AR",
            "CA",
            "CO",
            "CT",
            "DE",
            "FL",
            "GA",
            "HI",
            "ID",
            "IL",
            "IN",
            "IA",
            "KS",
            "KY",
            "LA",
            "ME",
            "MD",
            "MA",
            "MI",
            "MN",
            "MS",
            "MO",
            "MT",
            "NE",
            "NV",
            "NH",
            "NJ",
            "NM",
            "NY",
            "NC",
            "ND",
            "OH",
            "OK",
            "OR",
            "PA",
            "RI",
            "SC",
            "SD",
            "TN",
            "TX",
            "UT",
            "VT",
            "VA",
            "WA",
            "WV",
            "WI",
            "WY",
            "AS",
            "DC",
            "FM",
            "GU",
            "MH",
            "MP",
            "PW",
            "PR",
            "VI",
            "AA",
            "AE",
            "AP",
        ];
        //Mexican states
        this.statesMx = [
            "AGUASCALIENTES",
            "BAJA CALIFORNIA",
            "BAJA CALIFORNIA SUR",
            "CAMPECHE",
            "COAHUILA DE ZARAGOZA",
            "COLIMA",
            "CHIAPAS",
            "CHIHUAHUA",
            "CDMX",
            "DURANGO",
            "GUANAJUATO",
            "GUERRERO",
            "HIDALGO",
            "JALISCO",
            "MÉXICO",
            "MICHOACÁN DE OCAMPO",
            "MORELOS",
            "NAYARIT",
            "NUEVO LEÓN",
            "OAXACA",
            "PUEBLA",
            "QUERÉTARO",
            "QUINTANA ROO",
            "SAN LUIS POTOSÍ",
            "SINALOA",
            "SONORA",
            "TABASCO",
            "TAMAULIPAS",
            "TLAXCALA",
            "VERACRUZ DE IGNACIO DE LA LLAVE",
            "YUCATÁN",
            "ZACATECAS",
        ];
        // Peruvian States
        this.statesPe = [
            "AMAZONAS",
            "ÁNCASH",
            "APURÍMAC",
            "AREQUIPA",
            "AYACUCHO",
            "CAJAMARCA",
            "CALLAO",
            "CUSCO",
            "HUANCAVELICA",
            "HUÁNUCO",
            "ICA",
            "JUNÍN",
            "LA LIBERTAD",
            "LAMBAYEQUE",
            "LIMA",
            "LORETO",
            "MADRE DE DIOS",
            "MOQUEGUA",
            "PASCO",
            "PIURA",
            "PUNO",
            "SAN MARTÍN",
            "TACNA",
            "TUMBES",
            "UCAYALI",
        ];
        //Colombian states
        this.departmentsCo = [
            "AMAZONAS",
            "ANTIOQUIA",
            "ARAUCA",
            "ATLÁNTICO",
            "BOLÍVAR",
            "BOYACÁ",
            "CALDAS",
            "CAQUETÁ",
            "CASANARE",
            "CAUCA",
            "CESAR",
            "CHOCÓ",
            "CÓRDOBA",
            "CUNDINAMARCA",
            "GUAINÍA",
            "GUAVIARE",
            "HUILA",
            "LA GUAJIRA",
            "MAGDALENA",
            "META",
            "NARIÑO",
            "NORTE DE SANTANDER",
            "PUTUMAYO",
            "QUINDÍO",
            "RISARALDA",
            "SAN ANDRÉS Y PROVIDENCIA",
            "SANTANDER",
            "SUCRE",
            "TOLIMA",
            "VALLE DEL CAUCA",
            "VAUPÉS",
            "VICHADA",
        ];
        //Canadian provinces and territories
        this.provinces = [
            "AB",
            "BC",
            "MB",
            "NB",
            "NL",
            "NS",
            "NT",
            "NU",
            "ON",
            "PE",
            "QC",
            "SK",
            "YT",
        ];
        //Brazilian States
        this.statesBr = [
            "ACRE",
            "ALAGOAS",
            "AMAPÁ",
            "AMAZONAS",
            "BAHIA",
            "CEARÁ",
            "DISTRITO FEDERAL",
            "ESPÍRITO SANTO",
            "GOIÁS",
            "MARANHÃO",
            "MATO GROSSO",
            "MATO GROSSO DO SUL",
            "MINAS GERAIS",
            "PARÁ",
            "PARAÍBA",
            "PARANÁ",
            "PERNAMBUCO",
            "PIAUÍ",
            "RIO DE JANEIRO",
            "RIO GRANDE DO NORTE",
            "RIO GRANDE DO SUL",
            "RONDÔNIA",
            "RORAIMA",
            "SANTA CATARINA",
            "SÃO PAULO",
            "SERGIPE",
            "TOCANTINS",
        ];
        //Ecuadroian states
        this.statesEc = [
            "AZUAY",
            "BOLÍVAR",
            "CAÑAR",
            "CARCHI",
            "CHIMBORAZO",
            "COTOPAXI",
            "EL ORO",
            "ESMERALDAS",
            "GALÁPAGOS",
            "GUAYAS",
            "IMBABURA",
            "LOJA",
            "LOS RÍOS",
            "MANABÍ",
            "MORONA",
            "SANTIAGO",
            "NAPO",
            "ORELLANA",
            "PASTAZA",
            "PICHINCHA",
            "SANTA ELENA",
            "SANTO DOMINGO DE LOS TSÁCHILAS",
            "SUCUMBÍOS",
            "TUNGURAHUA",
            "ZAMORA CHINCHIPE",
        ];
        //Paraguayan states
        this.statesPy = [
            "ALTO PARAGUAY",
            "ALTO PARANÁ",
            "AMAMBAY",
            "BOQUERÓN",
            "CAAGUAZÚ",
            "CAAZAPÁ",
            "CANINDEYÚ",
            "CENTRAL",
            "CONCEPCIÓN",
            "CORDILLERA",
            "GUAIRÁ",
            "ITAPÚA",
            "MISIONES",
            "ÑEEMBUCÚ",
            "PARAGUARÍ",
            "PRESIDENTE HAYES",
            "SAN PEDRO",
        ];
        this.startUp();
    }
    startUp() {
        //locale
        this.leadWindow.DlronGlobal_TemplateVersion =
            typeof this.leadWindow.DlronGlobal_TemplateVersion === "undefined"
                ? this.webTemplate.RESPONSIVE
                : this.leadWindow.DlronGlobal_TemplateVersion;
        this.leadWindow.DlronGlobal_DealerInfoCountry =
            typeof this.leadWindow.DlronGlobal_DealerInfoCountry === "undefined"
                ? 0
                : this.leadWindow.DlronGlobal_DealerInfoCountry;
        this.leadWindow.DlronGlobal_DealerLanguage =
            typeof this.leadWindow.DlronGlobal_DealerLanguage === "undefined"
                ? 1
                : this.leadWindow.DlronGlobal_DealerLanguage;
        const locale = this.leadWindow.DlronGlobal_DealerLanguage +
            "-" +
            this.leadWindow.DlronGlobal_DealerInfoCountry;
        this.currentLocale = Object.values(this.locale).includes(locale)
            ? locale
            : this.locale.enUS;
        switch (this.leadWindow.DlronGlobal_DealerInfoCountry) {
            case 0:
                this.currentCountry = "us";
                break;
            case 1:
                this.currentCountry = "ca";
                break;
            case 2:
                this.currentCountry = "mx";
                break;
            case 3:
                this.currentCountry = "co";
                break;
            case 4:
                this.currentCountry = "cl";
                break;
            case 5:
                this.currentCountry = "pe";
                break;
            case 6:
                this.currentCountry = "br";
                break;
            case 7:
                this.currentCountry = "ec";
                break;
            case 8:
                this.currentCountry = "py";
                break;
        }
        //error messages
        BuildErrorMessages.buildErrorMessages(this.defaultOverrides, this.locale, this.errMsg);
        const jq = window.$;
        if (jq === null || jq === void 0 ? void 0 : jq.validator) {
            Object.assign(jq.validator.messages, this.defaultOverrides[this.currentLocale]);
        }
        //validations
        // the parameters wont be so ugly once errormessages are in their own file
        personalInfo.createNameValidation(this.errMsg, this.currentLocale);
        phone.createPhoneValidation(this.leadWindow, this.errMsg, this.currentLocale);
        phone.createPhoneShortValidation(this.leadWindow, this.errMsg, this.currentLocale);
        personalInfo.createEmailValidation(this.errMsg, this.currentLocale);
        personalInfo.createZipcodeValidation(this.errMsg, this.currentLocale, this.locale);
        personalInfo.createVinValidation(this.errMsg, this.currentLocale);
        personalInfo.createStateValidation(this.errMsg, this.currentLocale, this.locale, this);
        personalInfo.createDateValidation(this.errMsg, this.currentLocale);
        governmentInfo.createLicenseValidation(this.errMsg, this.currentLocale);
        governmentInfo.createSsnValidation(this.errMsg, this.currentLocale, this.locale);
        personalInfo.createFileValidation(this.errMsg, this.currentLocale, this.optional);
        governmentInfo.createRutValidation(this.errMsg, this.currentLocale);
        governmentInfo.createCpfValidation(this.errMsg, this.currentLocale);
        governmentInfo.createCnpjValidation(this.errMsg, this.currentLocale);
        phone.createPhoneTypeValidation(this.errMsg, this.currentLocale);
        governmentInfo.createDniValidation(this.errMsg, this.currentLocale);
        governmentInfo.createCedulaValidation(this.errMsg, this.currentLocale);
        BuildDlronTypes.buildDlronTypes(this.dlronTypes, this.locale, this.currentCountry);
        //append style sheet to document to prevent placeholders from being affected by text-transform
        let cssRule = "<style>";
        // Mozilla Firefox 4 to 18
        cssRule += ":-moz-placeholder { text-transform: none; }\n";
        // Mozilla Firefox 19+
        cssRule += "::-moz-placeholder { text-transform: none; }\n";
        //WebKit browsers
        cssRule += "::-webkit-input-placeholder { text-transform: none; }\n";
        // Internet Explorer 10+
        cssRule += ":-ms-input-placeholder { text-transform: none !important; }\n";
        cssRule += "</style>";
        document.head.insertAdjacentHTML('beforeend', cssRule);
        if (!useTaggbaaOemTaggingShiftOnly_DO50909) {
            // Set Shift Session Id
            this.setShiftSessionId();
        }
    }
    addValidationMethod(name, method, errorMsg) {
        utils.addValidationMethod(name, method, errorMsg);
    }
    begin() {
        const token = window.DealeronLead.token;
        if (token.shouldRefresh()) {
            console.log("Refreshing token");
            fetch("/api/lead/new")
                .then(response => response.json())
                .then(data => {
                console.log("Response: ", data);
                token.refreshToken(data);
            })
                .catch(error => console.error('Token error:', error));
        }
    }
    initialize(selector, submissionMethod) {
        const leads = this;
        if (submissionMethod != null &&
            !this.submissionMethods.hasOwnProperty(submissionMethod)) {
            utils.log("initialize: initialization failed - there is no submission method '" +
                submissionMethod +
                "' added");
            return;
        }
        document.querySelectorAll(selector).forEach((element, index) => {
            const formId = element.getAttribute("id");
            if (formId == undefined) {
                utils.log("initialize: form does not have id attribute");
            }
            else {
                leads.setupValidate(formId, submissionMethod);
            }
        });
        this.initializePhoneInternationalization();
    }
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        //non-greedy capture of name=<textToGrab> ending with |, ; or the end of the string
        var nameRegex = String.raw `${name}(.*?)(\||;|$)`;
        var re = new RegExp(nameRegex);
        if (re.test(decodedCookie)) {
            return RegExp.$1;
        }
        else {
            return "";
        }
    }
    setupValidate(formId, submissionMethod) {
        var _a, _b;
        const leadWindow = this.leadWindow;
        const leads = this;
        const validationOptions = {
            errorClass: "has-error",
            validClass: "has-success",
            submitHandler: leads.setupSubmit(submissionMethod),
            ignore: ":hidden:not(.inputfile)",
            errorPlacement: function (label, element) {
                var _a, _b;
                const el = (_a = element[0]) !== null && _a !== void 0 ? _a : element;
                const lbl = (_b = label[0]) !== null && _b !== void 0 ? _b : label;
                if (el.getAttribute("type") === "checkbox") {
                    el.parentNode.appendChild(lbl);
                    lbl.insertAdjacentHTML("beforebegin", "<br>");
                }
                else {
                    el.insertAdjacentElement("afterend", lbl);
                }
                if (leadWindow.DealerOnTracker &&
                    typeof leadWindow.DealerOnTracker !== "undefined" &&
                    leadWindow.DealerOnTracker.trackerProvider ===
                        "ShiftDigitalTrackerWithDataLayer") {
                    if (leadWindow.TrackFormSubmissionError) {
                        leadWindow.TrackFormSubmissionError(el);
                    }
                    else {
                        utils.log("TrackFormSubmissionError is not defined, skipping OEM error tagging.");
                    }
                }
            },
            //when field becomes invalid
            highlight: function (element, errorClass, validClass) {
                //DealeronLead.log ("invalid: [" + element.value + "] fieldName: " + element.name);
                element.closest("div").classList.remove(validClass);
                element.closest("div").classList.add(errorClass);
            },
            //when field becomes valid
            unhighlight: function (element, errorClass, validClass) {
                //DealeronLead.log("valid: " + element.value);
                element.closest("div").classList.remove(errorClass);
                element.closest("div").classList.add(validClass);
            },
        };
        const jq = window.$;
        if (jq) {
            jq("#" + formId).validate(validationOptions);
        }
        //add validation et al. to fields
        const curDlronTypes = this.dlronTypes[this.currentLocale];
        for (const dlronType in curDlronTypes) {
            const fieldsSelector = utils.getFieldsSelector(formId, dlronType);
            //add validation rules
            if (curDlronTypes[dlronType].hasOwnProperty("validationMethods")) {
                for (const [key, value] of Object.entries(curDlronTypes[dlronType].validationMethods)) {
                    const ruleSettings = {};
                    ruleSettings[key] = value;
                    if (key === "phonePreferredContact") {
                        value.push({ formId: formId });
                    }
                    leads.attachValidation(ruleSettings, fieldsSelector);
                }
            }
            //add mask
            if (curDlronTypes[dlronType].hasOwnProperty("mask")) {
                const mask = curDlronTypes[dlronType].mask;
                this.attachMask(mask, fieldsSelector);
            }
            //add text transform
            if (curDlronTypes[dlronType].hasOwnProperty("transform")) {
                this.attachTransform(curDlronTypes[dlronType].transform, fieldsSelector);
            }
            //add placeholder
            if (curDlronTypes[dlronType].hasOwnProperty("placeholder")) {
                document.querySelectorAll(fieldsSelector).forEach((element) => {
                    if (!element.hasAttribute("placeholder")) {
                        element.setAttribute("placeholder", curDlronTypes[dlronType].placeholder);
                    }
                });
            }
            //add blur
            if (curDlronTypes[dlronType].hasOwnProperty("onBlur")) {
                document.querySelectorAll(fieldsSelector).forEach((element, index) => {
                    element.addEventListener("blur", curDlronTypes[dlronType].onBlur);
                });
            }
            //add autocomplete hinting
            if (curDlronTypes[dlronType].hasOwnProperty("autocomplete")) {
                document.querySelectorAll(fieldsSelector).forEach((element) => {
                    element.setAttribute("autocomplete", curDlronTypes[dlronType].autocomplete);
                });
            }
            //add data attributes preferring already set attributes
            if (curDlronTypes[dlronType].hasOwnProperty("dataAttributes")) {
                document.querySelectorAll(fieldsSelector).forEach((el) => {
                    const htmlEl = el;
                    const attributes = curDlronTypes[dlronType].dataAttributes;
                    for (const prop in attributes) {
                        if (attributes.hasOwnProperty(prop) && htmlEl.dataset[prop] == null) {
                            htmlEl.dataset[prop] = attributes[prop];
                        }
                    }
                });
            }
            //initialize preferred contact selector
            if (dlronType == "preferredcontact" && document.querySelectorAll(fieldsSelector).length) {
                document.querySelectorAll(fieldsSelector).forEach(function (element, index) {
                    //Update requirements on page load
                    leads.updateRequirementsFromPreferredContact(element, formId);
                    //Add event listener to update appropriate field
                    element.addEventListener('change', function () {
                        leads.updateRequirementsFromPreferredContact(element, formId);
                    });
                });
            }
            const fieldElements = document.querySelectorAll(fieldsSelector);
            //initialize date fields
            if (dlronType == "date" && fieldElements.length) {
                const moment = leadWindow.moment;
                if (moment) {
                    switch (this.currentLocale) {
                        case this.locale.enUS:
                        case this.locale.enCA:
                            moment.lang("en");
                            break;
                        case this.locale.esUS:
                        case this.locale.esMX:
                        case this.locale.esPE:
                        case this.locale.esCO:
                        case this.locale.esCL:
                        case this.locale.esEC:
                        case this.locale.esPY:
                            moment.lang("es");
                            break;
                        case this.locale.ptBR:
                            moment.lang("pt");
                            break;
                    }
                }
                else {
                    utils.log("moment.js needed but not loaded");
                }
                const jqDate = window.$;
                if (!((_a = jqDate === null || jqDate === void 0 ? void 0 : jqDate.fn) === null || _a === void 0 ? void 0 : _a.combodate)) {
                    utils.log("JQuery plugin Combodate needed but not loaded");
                }
                else {
                    jqDate(fieldsSelector).combodate({
                        smartDays: true,
                        //"dateWidget" is to ignore dropdown fields when submitting form
                        //"form-control pull-left" is for responsive styling
                        customClass: "dateWidget form-control pull-left",
                        firstItem: "name",
                        errorClass: "combodateInvalid",
                        afterChange: function (element) {
                            element.valid();
                        },
                        customWidgetClass: "input-group",
                    });
                }
            }
            //initialize money fields
            if (dlronType == "money" && fieldElements.length) {
                const jqMoney = window.$;
                if (!((_b = jqMoney === null || jqMoney === void 0 ? void 0 : jqMoney.fn) === null || _b === void 0 ? void 0 : _b.maskMoney)) {
                    utils.log("JQuery plugin maskMoney needed but not loaded");
                }
                else {
                    // Assuming all money inputs will have the same currency details
                    const dataset = fieldElements[0].dataset;
                    const currencySymbol = dataset.currencySymbol;
                    const thousandsSeparator = dataset.thousandsSeparator;
                    const decimalSeparator = dataset.decimalSeparator;
                    jqMoney(fieldsSelector).maskMoney({
                        prefix: currencySymbol,
                        thousands: thousandsSeparator,
                        decimal: decimalSeparator,
                        allowZero: true,
                    });
                }
            }
            //file upload callback
            if (dlronType == "file" && fieldElements.length) {
                fieldElements.forEach((el) => {
                    const field = el;
                    field.addEventListener("change", function (e) {
                        const fileEventTarget = e.target;
                        const files = fileEventTarget.files;
                        leads.uploadedFiles[fileEventTarget.name] = [];
                        for (let i = 0; i < files.length; i++) {
                            const file = files[i];
                            const reader = new FileReader();
                            reader.onload = (function (theFile, inputName) {
                                return function (e) {
                                    const object = {
                                        Name: theFile.name,
                                        Type: theFile.type,
                                        Content: e.target.result,
                                    };
                                    leads.uploadedFiles[inputName].push(object);
                                };
                            })(file, fileEventTarget.name);
                            reader.readAsDataURL(file);
                        }
                        let labelText = "";
                        if (files.length == 0) {
                            labelText = leads.errMsg[leads.currentLocale].browse;
                        }
                        else if (files.length > 1) {
                            labelText = leads.errMsg[leads.currentLocale].filesSelected.replace("{count}", files.length);
                        }
                        else {
                            labelText = fileEventTarget.value.split("\\").pop();
                        }
                        document.querySelector(".inputfileLabel[for=" + fileEventTarget.id + "]").textContent = labelText;
                    });
                    field.style.width = "0.1px";
                    field.style.height = "0.1px";
                    field.style.opacity = "0";
                    field.style.overflow = "hidden";
                    field.style.zIndex = "-1";
                    field.classList.add("inputfile");
                    field.insertAdjacentHTML("beforebegin", `<label for="${field.id}" class="btn btn-cta inputfileLabel">${leads.errMsg[leads.currentLocale].browse}</label>`);
                });
            }
        }
    }
    //creates a closure
    setupSubmit(submissionMethod) {
        const subMethod = submissionMethod;
        const leadWindow = this.leadWindow;
        const leads = this;
        function submit(form) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return __awaiter(this, void 0, void 0, function* () {
                form.querySelectorAll("input[type='submit'], button[type='submit']").forEach((el) => {
                    el.disabled = true;
                });
                const subObj = subMethod == null ? {} : leads.submissionMethods[subMethod];
                leadWindow.dataList = {};
                const extendedFields = [];
                const honeypotFields = new Map();
                // Store the first email on the phone for FCA tagging
                // Retrieve entry URL
                leadWindow.dataList.EntryUrl = leads.entryUrl || "";
                // Identify this as a platform form (For now, custom forms don't use DealeronLead)
                extendedFields.push({ name: "IsPlatformForm", value: true });
                //Set Referrer data
                if ((_a = leadWindow.DealerOn_Referrer_Data) === null || _a === void 0 ? void 0 : _a.hasData()) {
                    const referrerData = leadWindow.DealerOn_Referrer_Data.getCookieData();
                    leads.thirdPartyJsonAdapter.setData({
                        ReferrerData: referrerData,
                    });
                }
                const mitsubishiUniteSessionId = leads.getMitsubishiUniteSessionId();
                if (mitsubishiUniteSessionId) {
                    leads.thirdPartyJsonAdapter.setData({
                        MiDSWebsiteCustomerId: mitsubishiUniteSessionId,
                    });
                }
                if (useTaggbaaOemTaggingShiftOnly_DO50909) {
                    // Set Shift Session Id
                    leads.ShiftSessionId = (_b = leadWindow.TaggingUtils) === null || _b === void 0 ? void 0 : _b.ShiftSessionId;
                }
                // Get Shift Session Id
                if (leads.ShiftSessionId) {
                    extendedFields.push({
                        name: "ShiftSessionId",
                        value: leads.ShiftSessionId,
                    });
                }
                //Get Custom Form Id
                const customFormIdEl = form.querySelector("input[type='hidden'][name='customFormId']");
                if (customFormIdEl) {
                    extendedFields.push({ name: "CustomFormId", value: customFormIdEl.value });
                }
                //Get Custom Form Email Subject
                const emailSubjectEl = form.querySelector("input[type='hidden'][name='emailSubject']");
                if (emailSubjectEl) {
                    extendedFields.push({ name: "EmailSubject", value: emailSubjectEl.value });
                }
                //Get Custom Form Email Type
                const emailTypeEl = form.querySelector("input[type='hidden'][name='emailType']");
                if (emailTypeEl) {
                    extendedFields.push({ name: "EmailType", value: emailTypeEl.value });
                }
                //Get AID for AutoNation Dealers
                if (leadWindow.utag) {
                    const utagCookieId = (_e = (_d = (_c = leadWindow.utag) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.cookie_id) !== null && _e !== void 0 ? _e : "";
                    const utagSessionId = (_h = (_g = (_f = leadWindow.utag) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.session_id) !== null && _h !== void 0 ? _h : "";
                    extendedFields.push({
                        name: "AID",
                        value: utagCookieId + "." + utagSessionId,
                    });
                }
                // Get FTID from TAG for Stellantis Apex leads
                if ((_j = leadWindow.FcaLeadUtils) === null || _j === void 0 ? void 0 : _j.formTransactionId) {
                    extendedFields.push({
                        name: "FTID",
                        value: leadWindow.FcaLeadUtils.formTransactionId,
                    });
                }
                if (subObj.hasOwnProperty("overrideApiSubmission")) {
                    subObj.overrideApiSubmission(form);
                }
                else {
                    if (subObj.hasOwnProperty("preSubmit")) {
                        subObj.preSubmit(form);
                    }
                    let leadSource = undefined;
                    if (subObj.hasOwnProperty("leadSource")) {
                        if (typeof subObj.leadSource == "number") {
                            leadSource = subObj.leadSource;
                        }
                        else {
                            leadSource = subObj.leadSource(form);
                        }
                    }
                    else {
                        const ldSrcEl = form.querySelector("input[type='hidden'][name='leadSource']");
                        if (ldSrcEl) {
                            leadSource = ldSrcEl.value;
                        }
                    }
                    //get form fields
                    if (subObj.submitFields != false) {
                        const radioAndCheckBoxes = [];
                        const formInputSelector = "input:not([type='submit']):not([type='hidden']):not(.dateWidget):not([data-dlron-lead-ignored])," +
                            "select:not(.dateWidget):not([data-dlron-lead-ignored])," +
                            "textarea:not(.dateWidget):not([data-dlron-lead-ignored])";
                        Array.from(form.querySelectorAll(formInputSelector)).forEach((el, index) => {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            const curField = el;
                            const fieldName = curField.getAttribute("name");
                            //if extended field aka custom field
                            if (curField.getAttribute("data-dlron-ext") == "true") {
                                const fieldValue = curField.value == null ? "" : curField.value;
                                extendedFields.push({ Name: fieldName, Value: fieldValue });
                            }
                            else {
                                const fieldType = curField.getAttribute("type");
                                if (fieldType == "checkbox" || fieldType == "radio") {
                                    if (radioAndCheckBoxes.indexOf(fieldName) == -1) {
                                        radioAndCheckBoxes.push(fieldName);
                                    }
                                }
                                else if (fieldType == "file") {
                                    leadWindow.dataList[curField.getAttribute("name")] =
                                        leads.uploadedFiles[curField.getAttribute("name")];
                                }
                                else if (fieldType == "tel" &&
                                    curField.getAttribute("data-dlron-type").startsWith("phone")) {
                                    const formId = "#" + curField.form.id;
                                    const fieldId = "#" + curField.id;
                                    const formField = document.querySelector(formId + " " + fieldId);
                                    const itlInstance = (_a = leadWindow.intlTelInputGlobals) === null || _a === void 0 ? void 0 : _a.getInstance(formField);
                                    const selectedCountry = itlInstance
                                        ? itlInstance.getSelectedCountryData().iso2.toLowerCase()
                                        : "";
                                    const extension = itlInstance
                                        ? itlInstance.getExtension()
                                        : "";
                                    const fullExtension = extension ? "x" + extension : "";
                                    switch (selectedCountry) {
                                        case "cl":
                                            if (formField.inputmask) {
                                                let unmaskedPhone = formField.inputmask
                                                    .unmaskedvalue()
                                                    .replace(/\s+/g, "")
                                                    .replace(/_+/g, "");
                                                const customPhone = "+" +
                                                    itlInstance.getSelectedCountryData().dialCode +
                                                    unmaskedPhone +
                                                    fullExtension;
                                                leadWindow.dataList[curField.getAttribute("name")] =
                                                    customPhone;
                                            }
                                            else {
                                                leadWindow.dataList[curField.getAttribute("name")] =
                                                    itlInstance.getNumber() + fullExtension;
                                            }
                                            break;
                                        default:
                                            if (itlInstance) {
                                                leadWindow.dataList[curField.getAttribute("name")] =
                                                    itlInstance.getNumber() + fullExtension;
                                            }
                                            else {
                                                if (formField.inputmask) {
                                                    let unmaskedPhone = formField.value
                                                        ? formField.value.replace(/[()\s_-]/g, "")
                                                        : "";
                                                    leadWindow.dataList[curField.getAttribute("name")] =
                                                        unmaskedPhone;
                                                }
                                                else {
                                                    leadWindow.dataList[curField.getAttribute("name")] =
                                                        formField.value;
                                                }
                                            }
                                    }
                                }
                                else {
                                    if (curField.getAttribute("name") &&
                                        curField.getAttribute("name") !== "RUT") {
                                        leadWindow.dataList[curField.getAttribute("name")] =
                                            curField.value == null ? "" : curField.value;
                                    }
                                }
                            }
                            if (fieldName == "CCPA_Consent") {
                                let disclaimer = "";
                                const consentFieldValue = curField.checked ? "Checked" : "Unchecked";
                                disclaimer = (_c = (_b = form.querySelector("[name='CCPA_Disclaimer']")) === null || _b === void 0 ? void 0 : _b.textContent) !== null && _c !== void 0 ? _c : "";
                                leads.thirdPartyJsonAdapter.setData({
                                    CCPA_Consent: consentFieldValue,
                                    CCPA_Disclaimer: disclaimer,
                                });
                            }
                            if (fieldName == "TCPA_Consent") {
                                let disclaimer = "";
                                const consentFieldValue = curField.checked ? "Opted In" : "Opted Out";
                                disclaimer = (_e = (_d = form.querySelector("[name='TCPA_Disclaimer']")) === null || _d === void 0 ? void 0 : _d.textContent) !== null && _e !== void 0 ? _e : "";
                                leads.thirdPartyJsonAdapter.setData({
                                    TCPA_Consent: consentFieldValue,
                                    TCPA_Disclaimer: disclaimer,
                                });
                            }
                            if (fieldName == "TCPA_Consent_Generic") {
                                let disclaimer = "";
                                const consentFieldValue = curField.checked ? "Opted In" : "Opted Out";
                                const associatedLabel = form.querySelector(`label[for="${curField.id}"]`);
                                disclaimer = (_h = (_g = (associatedLabel
                                    ? associatedLabel.textContent
                                    : (_f = curField.parentElement) === null || _f === void 0 ? void 0 : _f.textContent)) === null || _g === void 0 ? void 0 : _g.trim()) !== null && _h !== void 0 ? _h : "";
                                leads.thirdPartyJsonAdapter.setData({
                                    TCPA_Consent_Text: consentFieldValue,
                                    TCPA_Text_Disclaimer: disclaimer,
                                });
                            }
                            if (fieldName == "RUT") {
                                const rutFieldValue = curField.value;
                                leads.thirdPartyJsonAdapter.setData({ RUT: rutFieldValue });
                            }
                        });
                        radioAndCheckBoxes.forEach((value) => {
                            const checkedInputs = Array.from(form.querySelectorAll(`input[name='${value}']:checked`));
                            leadWindow.dataList[value] = checkedInputs.map((el) => el.value).join();
                        });
                        if (leadbaaGA4Comment_DO56658) {
                            const gaClientId = localStorage.getItem('ga_client_id');
                            if (gaClientId != null) {
                                extendedFields.push({ name: "ga_client_id", value: gaClientId });
                            }
                        }
                    }
                    if (apexCreditExtendedFields_OEM14704 || subObj.submitFields != false) {
                        const receiveInfoEl = form.querySelector("input[name='ReceiveInfoOption']");
                        if (receiveInfoEl) {
                            const receiveInfoFieldValue = receiveInfoEl.checked ? "true" : "false";
                            extendedFields.push({
                                Name: "ReceiveInfoOption",
                                Value: receiveInfoFieldValue,
                            });
                        }
                        if (form.querySelector("input[name=siebelFormId]")) {
                            extendedFields.push({
                                name: "FormId",
                                value: form.querySelector("input[name=siebelFormId]").value,
                            });
                        }
                        if (leadWindow.DlronGlobal_IsBotDocEnabled == true &&
                            ((_k = leadWindow.DlronGlobal_BotDocEnabledLeadSources) === null || _k === void 0 ? void 0 : _k.split(",").includes(`${leadSource}`))) {
                            extendedFields.push({ name: "GetBotDocUrl", value: true });
                        }
                        else {
                            extendedFields.push({ name: "GetBotDocUrl", value: false });
                        }
                        if (sessionStorage.getItem("eventid")) {
                            extendedFields.push({
                                name: "AdobeEventId",
                                value: sessionStorage.getItem("eventid"),
                            });
                        }
                        const submitInput = form.querySelector('[type="submit"]');
                        if (form.querySelector('input[name="ctaName"]')) {
                            extendedFields.push({
                                name: "CtaName",
                                value: form.querySelector('input[name="ctaName"]').value,
                            });
                        }
                        else if (submitInput) {
                            const value = submitInput.innerText === null ||
                                submitInput.innerText.trim() === ""
                                ? submitInput.value
                                : submitInput.innerText;
                            extendedFields.push({ name: "CtaName", value: value });
                        }
                        if (extendedFields.length > 0) {
                            leadWindow.dataList.ExtendedFields = extendedFields;
                        }
                        const faxEl = form.querySelector("input[name='fax_number']");
                        if (faxEl) {
                            honeypotFields.set("fax_number", faxEl.value);
                        }
                        const addressLine3El = form.querySelector("input[name='address_line3']");
                        if (addressLine3El) {
                            honeypotFields.set("address_line3", addressLine3El.value);
                        }
                        const uiStateEl = form.querySelector("input[name='ui_state']");
                        if (uiStateEl) {
                            honeypotFields.set("ui_state", uiStateEl.value);
                        }
                        if (honeypotFields.size > 0) {
                            const objFromMap = Object.fromEntries(honeypotFields);
                            leadWindow.dataList.HoneypotFields = JSON.stringify(objFromMap);
                        }
                    }
                    //get core values (lead source and type
                    if (subObj.submitCoreValues != false) {
                        if (leadSource !== undefined) {
                            leadWindow.dataList["LeadSource"] = leadSource;
                        }
                        if (subObj.hasOwnProperty("leadType")) {
                            if (typeof subObj.leadType == "number") {
                                leadWindow.dataList["LeadType"] = subObj.leadType;
                            }
                            else {
                                leadWindow.dataList["LeadType"] = subObj.leadType(form);
                            }
                        }
                        else {
                            const ldType = form.querySelector("input[type='hidden'][name='leadType']");
                            if (ldType) {
                                leadWindow.dataList["LeadType"] = ldType.value;
                            }
                        }
                        if (subObj.hasOwnProperty("vehicleType")) {
                            if (typeof subObj.vehicleType == "string") {
                                leadWindow.dataList["VehicleType"] = subObj.vehicleType;
                            }
                        }
                        const ua = (_l = window.$) === null || _l === void 0 ? void 0 : _l.ua;
                        if (ua == undefined) {
                            utils.log("UA Parser not loaded");
                        }
                        else {
                            leadWindow.dataList["Browser"] = [
                                ua.browser.name,
                                ua.browser.version,
                            ]
                                .join(" ")
                                .trim();
                            leadWindow.dataList["OS"] = [ua.os.name, ua.os.version]
                                .join(" ")
                                .trim();
                            leadWindow.dataList["Device"] = [ua.device.vendor, ua.device.model]
                                .join(" ")
                                .trim();
                        }
                    }
                    //add additional data
                    if (subObj.hasOwnProperty("additionalData")) {
                        const additionalObj = subObj.additionalData(form);
                        for (const prop in additionalObj) {
                            if (additionalObj.hasOwnProperty(prop)) {
                                if (prop === "Comments" &&
                                    leadWindow.dataList[prop] &&
                                    additionalObj[prop] !== leadWindow.dataList[prop] &&
                                    !additionalObj[prop].includes(leadWindow.dataList[prop])) {
                                    leadWindow.dataList[prop] = `${leadWindow.dataList[prop]}, ${additionalObj[prop]}`;
                                }
                                else if (prop === "ExtendedFields" &&
                                    leadWindow.dataList[prop]) {
                                    /* Cover where extended fields need to be added manually like in MvcPreapproved.ts */
                                    leadWindow.dataList[prop] = leadWindow.dataList[prop].concat(additionalObj[prop]);
                                }
                                else {
                                    leadWindow.dataList[prop] = additionalObj[prop];
                                }
                            }
                        }
                    }
                    if (leads.thirdPartyJsonAdapter.hasData()) {
                        leadWindow.dataList["ThirdPartyJson"] = JSON.stringify(leads.thirdPartyJsonAdapter.getData());
                    }
                    if (subObj.submitCoreValues) {
                        if (!leadWindow.dataList.hasOwnProperty("LeadType")) {
                            utils.log("no lead type specified");
                        }
                        if (!leadWindow.dataList.hasOwnProperty("LeadSource")) {
                            utils.log("no lead source specified");
                        }
                    }
                    try {
                        if (!leadWindow.ga || !leadWindow.ga.getByName) {
                            throw new Error("Google Analytics Not Initialized");
                        }
                        const gaTracker = leadWindow.ga.getByName("tracker1");
                        if (gaTracker) {
                            leadWindow.dataList["GaClientId"] = gaTracker.get("clientId");
                        }
                    }
                    catch (err) {
                        console.log(err);
                        console.log("Submitting lead without ga data.");
                    }
                    //DisplayType track whether a form was submitted in a modal or in-page
                    if (leadWindow.DealerOnTracker &&
                        typeof leadWindow.DealerOnTracker !== "undefined" &&
                        leadWindow.DealerOnTracker.trackerProvider ===
                            "ShiftDigitalTrackerWithDataLayer") {
                        leadWindow.dataList["DisplayType"] = document.body.classList.contains("modal-open")
                            ? "modal"
                            : "in-page";
                    }
                    //store cookie
                    LeadTrackerCoockie.storeLeadTrackerCookie(leadWindow);
                    // Hash and store email for FCA Merkle tracking
                    // leadWindow.TaggingUtils is only defined when the TAGGBAA toggle is enabled, we will follow up and pull this out
                    if (typeof leadWindow.FcaLeadUtils == "function" &&
                        !leadWindow.TaggingUtils) {
                        const firstEmailField = form.querySelector("[type='email'], [data-dlron-type='email'], [name='Email']");
                        const firstEmail = firstEmailField
                            ? firstEmailField.value.trim().toLowerCase()
                            : null;
                        if (firstEmail) {
                            yield (FcaLeadUtils === null || FcaLeadUtils === void 0 ? void 0 : FcaLeadUtils.hashAndStoreEmail(firstEmail));
                        }
                    }
                    //submit
                    let endpoint = subObj.hasOwnProperty("endpoint")
                        ? subObj.endpoint
                        : "/api/lead/save/#TOKEN#";
                    endpoint = endpoint.replace(/#TOKEN#/gi, leads.token.value);
                    const safeHashPii = (value, field) => __awaiter(this, void 0, void 0, function* () {
                        var _m;
                        try {
                            return yield ((_m = leadWindow.TaggingUtils) === null || _m === void 0 ? void 0 : _m.hashPii(value, field));
                        }
                        catch (e) {
                            utils.log("hashPii threw: " + describeError(e));
                            return undefined;
                        }
                    });
                    const trackFormSubmission = (response) => {
                        try {
                            if (leadWindow.TrackFormSubmission) {
                                leadWindow.TrackFormSubmission(response.leadId, leadWindow.dataList["LeadSource"], response.leadSource, form);
                            }
                            else {
                                utils.log("TrackFormSubmission is not defined, skipping OEM tagging.");
                            }
                        }
                        catch (e) {
                            utils.log("TrackFormSubmission threw: " + describeError(e));
                        }
                    };
                    fetch(endpoint, {
                        method: "POST",
                        headers: { 'Content-Type': 'application/json; charset=utf-8' },
                        body: JSON.stringify(leadWindow.dataList)
                    })
                        .then(response => {
                        if (!response.ok) {
                            console.log("Error: ", response);
                            throw new Error(`Response status: ${response.status}; Message: ${response.json()}`);
                        }
                        return response.json();
                    })
                        .then(data => {
                        if (leadbaaTaggingPiiFix_DO48757) {
                            (() => __awaiter(this, void 0, void 0, function* () {
                                leads.token.consumed = true;
                                /* DEV-22233 Support string and object */
                                if (typeof data === "object") {
                                    data = JSON.stringify(data);
                                }
                                // Dispatch event that the lead was successfully submitted
                                form.dispatchEvent(new CustomEvent("leadSubmissionSuccess"));
                                //BEGIN - TAGGING EVENT
                                const response = JSON.parse(data);
                                form.dispatchEvent(new CustomEvent("dotagging.event", {
                                    bubbles: true,
                                    detail: {
                                        data: {
                                            event: "lead_submitted",
                                            submission_id: response.leadId,
                                            sha256_email_address: yield safeHashPii(leadWindow.dataList.Email, FormField.email),
                                            sha256_phone_number: yield safeHashPii(leadWindow.dataList.Phone, FormField.phone),
                                        },
                                    },
                                }));
                                //END - DOTAGGING EVENT
                                /* OEM Tagging EVENT */
                                trackFormSubmission(response);
                                /* END OEM Tagging EVENT */
                                if (subObj.hasOwnProperty("successCallback")) {
                                    subObj.successCallback(data);
                                }
                                else {
                                    leads.defaultSuccessCallBack(data);
                                }
                            }))();
                        }
                        else {
                            leads.token.consumed = true;
                            /* DEV-22233 Support string and object */
                            if (typeof data === "object") {
                                data = JSON.stringify(data);
                            }
                            // Dispatch event that the lead was successfully submitted
                            form.dispatchEvent(new CustomEvent("leadSubmissionSuccess"));
                            //BEGIN - TAGGING EVENT
                            const response = JSON.parse(data);
                            form.dispatchEvent(new CustomEvent("dotagging.event", {
                                bubbles: true,
                                detail: {
                                    data: {
                                        event: "lead_submitted",
                                        submission_id: response.leadId,
                                    },
                                },
                            }));
                            //END - DOTAGGING EVENT
                            /* OEM Tagging EVENT */
                            trackFormSubmission(response);
                            /* END OEM Tagging EVENT */
                            if (subObj.hasOwnProperty("successCallback")) {
                                subObj.successCallback(data);
                            }
                            else {
                                leads.defaultSuccessCallBack(data);
                            }
                        }
                    })
                        .catch(error => {
                        document.dispatchEvent(new CustomEvent("do-leads-submission-error", { detail: error }));
                        if (subObj.hasOwnProperty("errorCallback")) {
                            subObj.errorCallback();
                        }
                        else {
                            const catchSubmitBtn = form.querySelector("input[type='submit'], button[type='submit']");
                            if (catchSubmitBtn)
                                catchSubmitBtn.disabled = false;
                            alert(leads.errMsg[leads.currentLocale].submissionError);
                            utils.log("submission error: " + error.message);
                        }
                    });
                }
            });
        }
        return function (form) {
            void submit(form);
            return false;
        };
    }
    defaultSuccessCallBack(data) {
        let eventValue;
        const response = JSON.parse(data);
        const leadWindow = this.leadWindow;
        this.thirdPartyJsonAdapter.reset();
        if (typeof leadWindow.DealeronCookie == "object") {
            let dataString = "";
            if (response.hasOwnProperty("internalId")) {
                dataString += "InternalId=" + response["internalId"] + "|";
            }
            const daysToKeep = 30 * 60; // 30 minutes converted to seconds
            leadWindow.DealeronCookie.setItem(leadWindow.DlronGlobal_DealeronLeadResponseCookieName, dataString, daysToKeep);
        }
        if (typeof DealerOnTrack !== "undefined" && DealerOnTrack) {
            DealerOnTrack.event("Lead", response.leadId, response.leadSource, eventValue, function (leadId) {
                if (self === top) {
                    leadWindow.location.href = "/thankyou.aspx?&lid=" + leadId;
                }
                else {
                    //lead form from iframe
                    top.location.href = "/thankyou.aspx?&lid=" + leadId;
                }
            });
        }
        else {
            utils.log("DealerOnTrack is not defined, redirecting to thank you page directly.");
            if (self === top) {
                leadWindow.location.href = "/thankyou.aspx?&lid=" + response.leadId;
            }
            else {
                top.location.href = "/thankyou.aspx?&lid=" + response.leadId;
            }
        }
    }
    getMitsubishiUniteSessionId() {
        return this.leadWindow.adp_foureyes_id;
    }
    setShiftSessionId() {
        if (this.leadWindow.sd) {
            this.leadWindow.sd("getSessionId", (sessionId) => {
                this.ShiftSessionId = sessionId;
            });
        }
    }
    //attachValidation
    attachValidation(validationsObj, selector) {
        const jq = window.$;
        const fieldsFound = document.querySelectorAll(selector);
        const fieldValidationIdsComplete = [];
        //if check is to prevent "element is undefined" js error
        if (fieldsFound && fieldsFound.length > 0) {
            for (let i = 0; i < fieldsFound.length; i++) {
                if (fieldValidationIdsComplete.indexOf(fieldsFound[i].id) < 0) {
                    if (jq) {
                        jq(fieldsFound[i]).rules("add", validationsObj);
                    }
                    fieldValidationIdsComplete.push(fieldsFound[i].id);
                }
            }
        }
    }
    //attachMask
    attachMask(maskConfiguration, selector) {
        const selected = document.querySelectorAll(selector);
        for (const unmaskedElement of selected) {
            unmaskedElement.addEventListener("focus", this.loadInputMaskScript.bind(this, maskConfiguration));
        }
    }
    loadInputMaskScript(maskConfiguration, evt) {
        var _a, _b;
        let leadWindow = (_a = this.leadWindow) !== null && _a !== void 0 ? _a : window;
        const leads = this;
        evt.target.removeEventListener("focus", leads.loadInputMaskScript);
        const inputMaskScript = (_b = Array.from(document.querySelectorAll("script"))) === null || _b === void 0 ? void 0 : _b.filter((script) => { var _a; return (_a = script.src) === null || _a === void 0 ? void 0 : _a.includes("inputmask"); });
        if (!((inputMaskScript === null || inputMaskScript === void 0 ? void 0 : inputMaskScript.length) > 0)) {
            const script = document.createElement("script");
            script.setAttribute("src", "/resources/external/inputmask/inputmask.min.js");
            script.setAttribute("type", "text/javascript");
            this.inputMaskScriptElement = script;
            document.body.appendChild(script);
        }
        if (this.inputMaskIsLoaded) {
            if (typeof leadWindow.Inputmask == "function") {
                leadWindow.Inputmask(maskConfiguration).mask(evt.target);
            }
        }
        else {
            this.inputMaskScriptElement.addEventListener("load", () => {
                if (typeof leadWindow.Inputmask == "function") {
                    this.inputMaskIsLoaded = true;
                    leadWindow.Inputmask(maskConfiguration).mask(evt.target);
                }
            });
        }
    }
    //attachTransform
    attachTransform(transform, selector) {
        document.querySelectorAll(selector).forEach((el) => {
            el.style.textTransform = transform;
        });
    }
    //addSubmissionMethod
    addSubmissionMethod(name, options) {
        if (name == null) {
            utils.log("addSubmissionMethod: submission method name can't be null");
        }
        else {
            this.submissionMethods[name] = options;
        }
    }
    initializePhoneInternationalization() {
        if (document.readyState == "loading") {
            this.leadWindow.addEventListener("DOMContentLoaded", () => this.addPhoneInternationalization());
        }
        else {
            this.addPhoneInternationalization();
        }
    }
    addPhoneInternationalization() {
        var _a;
        const dealerCountry = this.currentCountry.toLowerCase();
        const leadWindow = this.leadWindow;
        const leads = this;
        if (dealerCountry == "us") {
            return;
        }
        const phoneInputs = document.querySelectorAll("[data-dlron-type^='phone']");
        for (let i = 0; i < phoneInputs.length; i++) {
            if (((_a = phoneInputs[i].dataset) === null || _a === void 0 ? void 0 : _a.dlronType) === "phoneType") {
                continue;
            }
            const phoneInput = phoneInputs[i];
            intlTelInput(phoneInput, {
                onlyCountries: ["us", "ca", "mx", "co", "cl", "pe", "br", "ec", "py"],
                formatOnDisplay: false,
                autoPlaceholder: "off",
                initialCountry: dealerCountry,
                preferredCountries: [dealerCountry],
                utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
            });
            phoneInput.addEventListener("countrychange", () => {
                var _a, _b;
                const fieldId = "#" + phoneInput.id;
                const formId = "#" + phoneInput.form.id;
                const fieldSelector = formId + " " + fieldId;
                const phoneField = document.querySelector(fieldSelector);
                const currentPhone = (_a = leadWindow.intlTelInputGlobals) === null || _a === void 0 ? void 0 : _a.getInstance(phoneField);
                const selectedCountry = currentPhone
                    .getSelectedCountryData()
                    .iso2.toLowerCase();
                const dataType = (_b = phoneField.dataset) === null || _b === void 0 ? void 0 : _b.dlronType;
                const currentMask = phone.getPhoneMask(!(dataType.toLowerCase() === "phone"), selectedCountry);
                leads.attachMask(currentMask, fieldSelector);
                if (dataType.toLowerCase() === "phone") {
                    leads.attachValidation({ phoneNanpValid: phone.getPhoneFormat(false, selectedCountry) }, fieldSelector);
                }
                else if (dataType.toLowerCase() === "phoneshort") {
                    leads.attachValidation({
                        phoneShortNanpValid: phone.getPhoneFormat(true, selectedCountry),
                    }, fieldSelector);
                }
                const element = document.querySelector(fieldSelector);
                element.blur();
                element.focus();
            });
        }
    }
    // Preferred contact update methods
    updateRequirementsFromPreferredContact(preferredContactElement, formId) {
        const preferredContactVal = preferredContactElement.value.toLowerCase();
        //Remove errors and required from other options
        Array.from(preferredContactElement.options).forEach((e) => {
            if (e.textContent.toLowerCase() !== preferredContactVal) {
                const fieldsSelector = this.getInputElementFromOption(e.value, formId);
                const fieldElement = document.querySelector(fieldsSelector);
                if (fieldElement) {
                    this.removeRequiredFromField(document.querySelector(fieldsSelector));
                }
            }
        });
        const curFieldsSelector = this.getInputElementFromOption(preferredContactVal, formId);
        this.addRequiredToField(document.querySelector(curFieldsSelector));
        // Show BMW disclaimer - DEV-16819 also used for MINI - CONPLAT-188
        const preferredContactDisclaimer = document.querySelector(`#${formId} [id^="preferredContactDisclaimerText"]`);
        if (preferredContactDisclaimer) {
            if (preferredContactVal === 'text' || preferredContactVal === 'phone') {
                preferredContactDisclaimer.style.display = 'block';
            }
            else {
                preferredContactDisclaimer.style.display = 'none';
            }
        }
    }
    // Remove Error classes, asterisk and required rule
    removeRequiredFromField(inputElement) {
        if (!inputElement || utils.isRequired(inputElement))
            return;
        document.querySelectorAll(".has-error:has(input[id=" + inputElement.getAttribute("id") + "])")
            .forEach((element) => {
            element.classList.remove("has-error");
        });
        document.querySelectorAll("label[for='" + inputElement.getAttribute("id") + "'].has-error")
            .forEach((element) => {
            element.remove();
        });
        document.querySelectorAll("label[for='" + inputElement.getAttribute("id") + "'].control-label")
            .forEach((element) => {
            const withoutAsterisk = element.textContent.replace("*", "");
            element.textContent = withoutAsterisk;
        });
        inputElement.required = false;
    }
    // Adds asterisk and makes field required
    addRequiredToField(inputElement) {
        if (!inputElement || utils.isRequired(inputElement))
            return;
        document.querySelectorAll("label[for='" + inputElement.getAttribute("id") + "'].control-label")
            .forEach((element) => {
            const before = element.textContent;
            element.textContent = "*" + before;
        });
        inputElement.required = true;
    }
    getInputElementFromOption(optionValue, formId) {
        const dlronTypeString = optionValue.toLowerCase() === "text"
            ? "phone"
            : optionValue.toLowerCase();
        return utils.getFieldsSelector(formId, dlronTypeString);
    }
}
